import * as React from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { AxiosResponse } from 'axios'
import RenderError from '../garvan-react/Components/ModalFeedback/RenderError'

function GenericModal({
  open,
  loading,
  error,
  setClose,
  setCommit,
  children,
  title,
  commitLabel = 'Save',
}: {
  open: boolean
  loading: boolean
  error: AxiosResponse | null
  setClose: any
  setCommit: any
  children?: any
  title: string
  commitLabel?: string
}) {
  return (
    <Dialog
      open={open}
      onClose={setClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent
        sx={{
          maxHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 550,
        }}
      >
        {!(loading || error) && children}
        {loading && (
          <Box
            sx={{ width: 1, display: 'flex', justifyContent: 'center', m: 1 }}
          >
            <CircularProgress />
          </Box>
        )}
        {error && <RenderError error={error} />}
      </DialogContent>
      <DialogActions>
        {!error ?
          <>
            <Button
              disabled={loading}
              color={'error'}
              onClick={setClose}
            >
              Cancel
            </Button>
            <Button
              disabled={loading || !setCommit}
              color={'success'}
              onClick={setCommit}
            >
              {commitLabel}
            </Button>
          </>
        : <Button
            disabled={loading}
            color={'error'}
            onClick={setClose}
          >
            OK
          </Button>
        }
      </DialogActions>
    </Dialog>
  )
}

export default GenericModal
